export const DialogTypes = {
  LOADING: "loading",
  CONFIRMATION: "confirmation",
  ERROR: "error",
};
